import React, { useEffect, useState, useRef } from "react";
import { bg, call, countryArr, eyeClose, eyeOpen,Logo } from "../../assets/img";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { APP_VERSION, ICON_FILTER, URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import useStore from "../redux/store/useStore";
import { Toast } from "../../Component/Toast";
import countryData from "../../Services/CountryData.json";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import eventBus from "../EventEmitterr/eventBus";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../MaskIcon";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  border: "1px solid #d0d0d0",
  backgroundColor: "#ffffffff",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto #8F0D3d",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
    ...theme.applyStyles("dark", {
      backgroundColor: "#30404d",
    }),
  },
  "input:disabled ~ &": {
    border: "none",
    background: "rgba(206,217,224,.5)",
    ...theme.applyStyles("dark", {
      background: "rgba(57,75,89,.5)",
    }),
  },
  ...theme.applyStyles("dark", {
    border: "1px solid rgb(16 22 26 / 40%)",
    backgroundColor: "#394b59",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))",
  }),
}));

const BpCheckedIcon = styled(BpIcon)({
  border: "none",
  backgroundColor: "#8F0D3d",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&::before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#8F0D3d",
  },
});

const Login = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [reminderActive, setReminderActive] = useState(false);
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({ password: "", mobile: "" });
  const [countryCode, setCountryCode] = useState("+91");
  const [country, setCountry] = useState("IN");
  const togglePassword = () => setShowPassword(!showPassword);
  const [isLoading, setIsloading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showHolidayPopup, setShowHolidayPopup] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((c) => c.iso === "IN") || countryData[0],
  );

  const { setUser, user } = useStore();
  // // console.log("user", user);
  // Add this state at the top with your other states
const [holidayInfo, setHolidayInfo] = useState(null); // { message: string }

// Parse date range from the error message
const parseHolidayMessage = (message) => {
  // e.g. "Holiday from 17-06-2026 to 18-06-2026"
  return message || "Holiday";
};

// Updated signin function
const signin = async (e) => {
  e.preventDefault();
  const newErrors = {};

  if (!validatePhone(mobile, country)) {
    newErrors.mobile = "Enter a valid phone number";
  } else if (mobile.length < maxLength) {
    newErrors.mobile = `Phone number must be at least ${maxLength} digits`;
  }

  if (!password || password.length < 4) {
    newErrors.password = "Password must be at least 4 characters";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

  const formdata = {
    mobile: cleanMobile,
    password: password,
    country_code: countryCode,
    version: APP_VERSION,
  };

  setIsloading(true);
  try {
  const res = await post(URLS.LOGIN, formdata);

  // ✅ Check for 403 holiday response
  if (res?.code === 403) {
    setHolidayInfo({ message: res.message });
    return;
  }

  if (res.status === "success") {
    Toast(res.message || "Login Successfully!");
    if (reminderActive) {
      setUser({
        name: res?.user?.name,
        id: res?.user?.id,
        mobile: res?.user?.mobile,
        country_code: res?.user?.country_code,
        password: password,
        remember_me: "true",
      });
      localStorage.setItem("token", res.token);
      localStorage.setItem("user_id", res?.user?.id);
      localStorage.setItem("last_active", moment().toString());
    } else {
      setUser({
        name: res?.user?.name,
        id: res?.user?.id,
        mobile: res?.user?.mobile,
      });
      sessionStorage.setItem("token", res.token);
    }
    eventBus.emit("newlogin");
    navigate("/home", { replace: true });
  }
} catch (err) {
  Toast("Login failed!");
} finally {
  setIsloading(false);
}
};
  const maxLength = selectedCountry?.maxLength;
  // // console.log("maxLength", maxLength);

  const getCheckedDetails = async () => {
    if (user?.remember_me == "true") {
      // // console.log("user-----", user);
      const userCode = user.country_code || "+91";
      setCountryCode(userCode);
      const matchingCountry =
        countryData.find((c) => c.code === userCode) ||
        countryData.find((c) => c.iso === "IN") ||
        countryData[0];
      setSelectedCountry(matchingCountry);
      setCountry(matchingCountry.iso);
      setMobile(user?.mobile || "");
      setPassword(user.password || "");
      setReminderActive(true);
    }
  };

  // // console.log("isFormValid", isFormValid);

  useEffect(() => {
    getCheckedDetails();
  }, []);

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setMobile(value);
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setCountry(country.iso);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const cleanDigits = mobile.replace(/[^\d]/g, "");
    // // console.log("cleanDigits", cleanDigits);
    // try {

    //   setIsPhoneValid(maxLength == cleanDigits.length);
    // } catch (e) {
    //   setIsPhoneValid(cleanDigits.length >= 7);
    // }
  }, [mobile, countryCode]);

  useEffect(() => {
    const isMobileValid =
      validatePhone(mobile, country) && mobile.length >= maxLength;
    const isPasswordValid = password.length >= 4;
    setIsFormValid(isMobileValid && isPasswordValid);
  }, [mobile, password, country, maxLength]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  // const signin = async (e) => {
  //   e.preventDefault();
  //   const newErrors = {};

  //   if (!validatePhone(mobile, country)) {
  //     newErrors.mobile = "Enter a valid phone number";
  //   } else if (mobile.length < maxLength) {
  //     newErrors.mobile = `Phone number must be at least ${maxLength} digits`;
  //   }

  //   if (!password || password.length < 4) {
  //     newErrors.password = "Password must be at least 4 characters";
  //   }

  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

  //   const formdata = {
  //     mobile: cleanMobile,
  //     password: password,
  //     country_code: countryCode,
  //     version: APP_VERSION,
  //   };
  //   setIsloading(true);
  //   try {
  //     const res = await post(URLS.LOGIN, formdata);
  //     // // console.log("res login", res);
  //     if (res.status === "success") {
  //       Toast(res.message || "Login Successfully!");
  //       if (reminderActive) {
  //         setUser({
  //           name: res?.user?.name,
  //           id: res?.user?.id,
  //           mobile: res?.user?.mobile,
  //           country_code: res?.user?.country_code,
  //           password: password,
  //           remember_me: "true",
  //         });
  //         localStorage.setItem("token", res.token);
  //         localStorage.setItem("user_id", res?.user?.id);
  //         localStorage.setItem("last_active", moment().toString());
  //       } else {
  //         setUser({
  //           name: res?.user?.name,
  //           id: res?.user?.id,
  //           mobile: res?.user?.mobile,
  //         });
  //         sessionStorage.setItem("token", res.token);
  //       }
  //       eventBus.emit("newlogin");
  //       setIsloading(false);
  //       navigate("/home", { replace: true });
  //     } else {
  //       setIsloading(false);
  //       // // console.log("Login failed:", res);
  //     }
  //   } catch (err) {
  //     // // console.log("login err:", err);
  //     setIsloading(false);
  //     Toast("Login failed!");
  //   } finally {
  //     setIsloading(false);
  //   }
  // };

  const downloadApk = () => {
    const link = document.createElement("a");
    link.href = process.env.PUBLIC_URL + "/Kandha.apk";
    link.setAttribute("download", "Kandha.apk");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 return (
  <div style={{ backgroundColor: '#F0EDE6', minHeight: '100vh', overflow: 'hidden' }}>
    
    {/* ===== DESKTOP LAYOUT (lg and above) ===== */}
    <div className="d-none d-lg-flex" style={{ height: '100vh' }}>
      
      {/* LEFT - Full height image */}
      <div style={{
        width: '50%',
        backgroundImage: "url('https://dl2n11pngizv0.cloudfront.net/kandhaags/Splash+screen.png')",
        backgroundColor: '#8F0D3d',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={Logo} alt="Logo" style={{ maxWidth: 400, width: '100%' }} />
      </div>

      {/* RIGHT - Centered form */}
      <div style={{
        width: '50%',
        backgroundColor: '#F0EDE6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}>
        <form style={{ width: '100%', maxWidth: 420 }}>
          <h2 style={{ color: 'black', fontSize: 20 }} className="f3"> Login</h2>

          {/* PHONE */}
          <div style={{ marginTop: 25 }} className="form-group text-start">
            <label style={{ color: '#8F0D3d' }} className="form-label f3 mb-0">
              Mobile Number
            </label>
            <div
              ref={dropdownRef}
              className="login-input mt-1"
              style={{
                height: 50,
                background: '#F0EDE6',
                display: 'flex',
                alignItems: 'center',
                borderRadius: 8,
                position: 'relative',
              }}
            >
              <button
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{
                  backgroundColor: '#6E6E6E',
                  border: '1px solid #8F0D3dCC',
                  color: '#ffffff',
                  fontSize: 16,
                  fontWeight: 600,
                  height: 50,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  borderRadius: '8px 0 0 8px',
                  padding: '0px 10px',
                  gap: 6,
                }}
              >
                <img src={countryArr} style={{ width: 14, height: 8 }} alt="" />
                {selectedCountry.code}
              </button>

              <input
                type="tel"
                name="phone"
                autoComplete="tel-national"
                inputMode="numeric"
                placeholder="Mobile Number"
                value={mobile}
                onKeyDown={(e) => {
                  if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault();
                }}
                onChange={handleMobileChange}
                className="placholdercolorchanges f2"
                style={{
                  flex: 1,
                  border: 'none',
                  outline: 'none',
                  backgroundColor: 'transparent',
                  fontSize: 16,
                  color: '#1B1B1B',
                  padding: '0 10px',
                  height: 50,
                }}
              />

              <img src={call} alt="call" style={{ marginRight: 12, width: 17 }} />

              {dropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: 52,
                  left: 0,
                  right: 0,
                  backgroundColor: '#ffffff',
                  border: '1px solid rgb(0 71 67 / 40%)',
                  borderRadius: 8,
                  maxHeight: 200,
                  overflowY: 'auto',
                  zIndex: 1000,
                }}>
                  {countryData.map((c) => (
                    <div
                      key={c.iso}
                      onClick={() => handleCountrySelect(c)}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid rgb(0 71 67 / 40%)',
                        backgroundColor: selectedCountry.iso === c.iso ? '#ffffff' : '#F0EDE6',
                      }}
                    >
                      {c.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          {/* PASSWORD */}
          <div style={{ marginTop: 25 }} className="form-group text-start">
            <label style={{ color: '#8F0D3d' }} className="form-label f3 mb-0">
              Password
            </label>
            <div className="login-input mt-1" style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                style={{
                  height: 50,
                  backgroundColor: '#F0EDE6',
                  borderRadius: 8,
                  fontSize: 16,
                  color: '#1B1B1B',
                }}
                required
                className="placholdercolorchanges f2"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((prev) => ({ ...prev, password: '' }));
                }}
              />
              <span
                onClick={togglePassword}
                style={{
                  cursor: 'pointer',
                  paddingRight: '10px',
                  backgroundColor: '#F0EDE6',
                  top:-1,
                  position: 'relative',
                }}
                className="password_color"
              >
                {showPassword ? (
                  <MaskIcon src={eyeOpen} className="imageOpen" style={{ marginTop: '10px'}} alt="" />
                ) : (
                  <MaskIcon src={eyeClose} className="imageClose" style={{ marginTop: '10px'}}  alt="" />
                )}
              </span>
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>

          {/* FORGOT */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }} className="mt-1">
            <p onClick={() => navigate('/forgot')} className="f3"
              style={{ cursor: 'pointer', width: 'fit-content', color: '#8F0D3d' }}>
              Forgot Password?
            </p>
          </div>

          {/* REMEMBER ME */}
          <div className="mt-1 f3">
            <Checkbox
              sx={{ '&:hover': { bgcolor: 'transparent' } }}
              disableRipple
              color="default"
              checkedIcon={<BpCheckedIcon />}
              onChange={(e) => setReminderActive(e.target.checked)}
              icon={<BpIcon />}
              checked={reminderActive}
              slotProps={{ input: { 'aria-label': 'Checkbox demo' } }}
            />
            <span style={{ top: 1, position: 'relative', color: 'black' }}>
              Remember me
            </span>
          </div>

          <SubmitButton
            onClick={signin}
            loading={isLoading}
            disabled={!isFormValid || isLoading}
            title="Sign In"
          />

          <p style={{ textAlign: 'center' }} className="f3 mt-3 gray"  style={{
    userSelect: "none",
    WebkitUserSelect: "none",
    WebkitTapHighlightColor: "transparent"
  }}>
            Don't have an account?{' '}
            <span onClick={() => navigate('/register')} className="f3 primary pointer" >
              Register Now
            </span>
          </p>

          <hr className="mt-3" />

          <SubmitButton onClick={downloadApk} title="Download Updated APK" isFormValid={false} />
        </form>
      </div>
    </div>

    {/* ===== MOBILE LAYOUT (below lg) ===== */}
    <div className="d-flex d-lg-none" style={{ flexDirection: 'column', minHeight: '100vh' }}>
      
      {/* TOP - Image */}
      <div style={{
        backgroundImage: "url('https://dl2n11pngizv0.cloudfront.net/kandhaags/Splash+screen.png')",
        backgroundColor: '#8F0D3d',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '45vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={Logo} alt="Logo" style={{width: '100%',
    maxWidth: '285px',
    maxHeight: '277px',
    position: 'relative',
    bottom: '12px'}} />
      </div>

      {/* BOTTOM - Form slides up */}
      <div style={{
        backgroundColor: '#F0EDE6',
        borderRadius: '60px 60px 0 0',
        marginTop: '-50px',
        zIndex: 1,
        position: 'relative',
        padding: '50px 24px 20px',
        flex: 1,
      }}>
        <form style={{ maxWidth: 420, width: '100%', margin: '0 auto' }}>
          <h2 style={{ color: 'black', fontSize: 20 }} className="f3">Login</h2>

          {/* PHONE */}
          <div style={{ marginTop: 20 }} className="form-group text-start">
            <label style={{ color: '#8F0D3d' }} className="form-label f3 mb-0">
              Mobile Number
            </label>
            <div
              ref={dropdownRef}
              className="login-input mt-1"
              style={{
                height: 50,
                background: '#F0EDE6',
                display: 'flex',
                alignItems: 'center',
                borderRadius: 8,
                position: 'relative',
              }}
            >
              <button
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{
                  backgroundColor: '#6E6E6E',
                  border: '1px solid #8F0D3dCC',
                  color: '#ffffff',
                  fontSize: 16,
                  fontWeight: 600,
                  height: 50,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  borderRadius: '8px 0 0 8px',
                  padding: '0px 10px',
                  gap: 6,
                }}
              >
                <img src={countryArr} style={{ width: 14, height: 8 }} alt="" />
                {selectedCountry.code}
              </button>

              <input
                type="tel"
                name="phone"
                autoComplete="tel-national"
                inputMode="numeric"
                placeholder="Mobile Number"
                value={mobile}
                onKeyDown={(e) => {
                  if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault();
                }}
                onChange={handleMobileChange}
                className="placholdercolorchanges f2"
                style={{
                  flex: 1,
                  border: 'none',
                  outline: 'none',
                  backgroundColor: 'transparent',
                  fontSize: 16,
                  color: '#1B1B1B',
                  padding: '0 10px',
                  height: 50,
                }}
              />

              <img src={call} alt="call" style={{ marginRight: 12, width: 17 }} />

              {dropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: 52,
                  left: 0,
                  right: 0,
                  backgroundColor: '#ffffff',
                  border: '1px solid rgb(0 71 67 / 40%)',
                  borderRadius: 8,
                  maxHeight: 200,
                  overflowY: 'auto',
                  zIndex: 1000,
                }}>
                  {countryData.map((c) => (
                    <div
                      key={c.iso}
                      onClick={() => handleCountrySelect(c)}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid rgb(0 71 67 / 40%)',
                        backgroundColor: selectedCountry.iso === c.iso ? '#ffffff' : '#F0EDE6',
                      }}
                    >
                      {c.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          {/* PASSWORD */}
          <div style={{ marginTop: 20 }} className="form-group text-start">
            <label style={{ color: '#8F0D3d' }} className="form-label f3 mb-0">
              Password
            </label>
            <div className="login-input mt-1" style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                style={{
                  height: 50,
                  backgroundColor: '#F0EDE6',
                  borderRadius: 8,
                  fontSize: 16,
                  color: '#1B1B1B',
                }}
                required
                className="placholdercolorchanges f2"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((prev) => ({ ...prev, password: '' }));
                }}
              />
              <span
                onClick={togglePassword}
                style={{
                  cursor: 'pointer',
                  paddingRight: '10px',
                  backgroundColor: '#F0EDE6',
                  top: 4,
                  position: 'relative',
                }}
                className="password_color"
              >
                {showPassword ? (
                  <MaskIcon src={eyeOpen} className="imageOpen" alt="" />
                ) : (
                  <MaskIcon src={eyeClose} className="imageClose" alt="" />
                )}
              </span>
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>

          {/* FORGOT */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }} className="mt-1">
            <p onClick={() => navigate('/forgot')} className="f3"
              style={{ cursor: 'pointer', width: 'fit-content', color: '#8F0D3d' }}>
              Forgot Password?
            </p>
          </div>

          {/* REMEMBER ME */}
          <div className="mt-1 f3">
            <Checkbox
              sx={{ '&:hover': { bgcolor: 'transparent' } }}
              disableRipple
              color="default"
              checkedIcon={<BpCheckedIcon />}
              onChange={(e) => setReminderActive(e.target.checked)}
              icon={<BpIcon />}
              checked={reminderActive}
              slotProps={{ input: { 'aria-label': 'Checkbox demo' } }}
            />
            <span style={{ top: 1, position: 'relative', color: 'black' }}>
              Remember me
            </span>
          </div>

          <SubmitButton
            onClick={signin}
            loading={isLoading}
            disabled={!isFormValid || isLoading}
            title="Sign In"
          />

          <p style={{ textAlign: 'center' }} className="f3 mt-3 gray">
            Don't have an account?{' '}
            <span onClick={() => navigate('/register')} className="f3 primary pointer" >
              Register Now
            </span>
          </p>

          <hr className="mt-3" />

          <SubmitButton onClick={downloadApk} title="Download Updated APK" isFormValid={false} />
        </form>
      </div>
    </div>
     {/* ===== HOLIDAY OVERLAY MODAL ===== */}
{/* ===== HOLIDAY OVERLAY MODAL ===== */}
{holidayInfo && (
  <div
    style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 9999,
      overflow: "hidden",
    }}
  >
    {/* Blurred background */}
    <div
      style={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        backgroundColor: "rgba(0,0,0,0.3)",
      }}
    />

    {/* Diagonal banner */}
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-35deg)",
        backgroundColor: "#8F0D3d",
        width: "160%",
        padding: "22px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
        cursor: "pointer",
      }}
      onClick={() => setShowHolidayPopup(true)}
    >
      <span
        className="f4"
        style={{
          color: "#ffffff",
          fontSize: 32,
          fontWeight: 800,
          letterSpacing: 4,
        }}
      >
        HOLIDAY
      </span>

      {/* ⓘ info circle */}
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "2.5px solid #ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          fontSize: 16,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        i
      </div>
    </div>

    {/* Small info popup */}
    {showHolidayPopup && (
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10000,
        }}
        onClick={() => setShowHolidayPopup(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: "#F0EDE6",
            borderRadius: 16,
            padding: "28px 24px",
            maxWidth: 300,
            width: "85%",
            textAlign: "center",
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          }}
        >
          <p className="f3" style={{ color: "#1B1B1B", fontSize: 15, lineHeight: 1.7, marginBottom: 20 }}>
            {holidayInfo.message}
          </p>
          <button
            onClick={() => setShowHolidayPopup(false)}
            style={{
              backgroundColor: "#8F0D3d",
              color: "#ffffff",
              border: "none",
              borderRadius: 10,
              padding: "10px 0",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
              width: "100%",
            }}
            className="f3"
          >
            Okay
          </button>
        </div>
      </div>
    )}
  </div>
)}
  </div>
);
};

export default Login;
